<template>
   <span class="badge rounded-pill font-size-11"
         :class="{
            'badge-soft-success': status === 'paid',
            'badge-soft-warning': status === 'partially paid',
            'badge-soft-info': status === 'deposited',
            'badge-soft-info': status === 'written off',
            'badge-soft-danger': status === 'unpaid',
            'badge-soft-dark': status === 'cancelled',
          }">
  {{payment_status}}</span>
</template>

<script>
export default {
name: "payment-status-component",
  props:{
    payment_status: {type: String}
  },
  computed: {
    status() {
      return this.payment_status.trim().toLowerCase()
    }
  }
}
</script>

<style scoped>

</style>
